import { ChevronDown, ExternalLink, LayoutGrid } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useOperator } from "@/context/OperatorContext";

export const LEVELS = {
  admin: "Full access",
  team_view_self_edit: "Can see team, edit own details",
  self_edit: "Can edit own details",
  self_view: "Can view own details",
};

const ITEMS = [
  ["profile", "My profile"],
  ["team", "Team"],
  ["emails", "Emails"],
  ["contacts", "Contacts & opt-outs"],
  ["business", "Business details"],
  ["plans", "Plans & billing"],
];

// Header shortcut to the Morr Access owner pages. Morr Access decides what each person can see/change.
export function MorrMenu() {
  const { operator } = useOperator() || {};
  const links = operator?.morr_links || {};
  const items = ITEMS.filter(([k]) => links[k]);
  if (!items.length && !links.apps) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="inline-flex items-center gap-1 border border-border px-2.5 h-8 text-xs font-medium hover:bg-secondary transition-colors" data-testid="morr-menu-trigger">
        Morr Access <ChevronDown className="h-3.5 w-3.5" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-none w-56" data-testid="morr-menu">
        {LEVELS[operator?.permission_level] && (
          <div className="px-2 py-2 text-xs border-b border-border" data-testid="morr-menu-level">
            Your access: <span className="font-semibold">{LEVELS[operator.permission_level]}</span>
          </div>
        )}
        <DropdownMenuLabel className="text-[10px] uppercase tracking-wider text-muted-foreground">Managed in Morr Access</DropdownMenuLabel>
        {items.map(([k, label]) => (
          <DropdownMenuItem key={k} asChild className="rounded-none cursor-pointer">
            <a href={links[k]} data-testid={`morr-menu-${k}`} className="flex items-center justify-between">{label} <ExternalLink className="h-3.5 w-3.5 opacity-60" /></a>
          </DropdownMenuItem>
        ))}
        {links.apps && <>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild className="rounded-none cursor-pointer">
            <a href={links.apps} data-testid="morr-menu-apps" className="flex items-center gap-2"><LayoutGrid className="h-3.5 w-3.5" /> All apps</a>
          </DropdownMenuItem>
        </>}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
